import ClockType from "../enums/clock-type";
import FieldLength from "../enums/field-length";
import GoalPost from "../enums/goal-post";
import PatPoints from "../enums/pat-points";
import ParticipationStyle from "../enums/participation-style";

const DefaultFootballConfig = Object.freeze({
    general: {
        periodsInRegulation: 4,
        downs: 4,
        fieldLength: FieldLength.OptionSeven.code,
        fieldWidth: 40,
        minutesByPeriod: 15,
        firstDownYards: 10,
        // TODO: this property shouldn't be here. This is part of the flag config.
        firstDownFlagStyle: -1,
        timeoutsPerHalf: 3,
        redZoneLength: 20,
        zoneLength: 20,
        endZoneLength: 10,
        includeEndZoneYardage: false,
        otTimeControl: false,
        autoFairCatchTb: false,
        rushType: false,
        passType: false,
        spikeTeamAttOnly: false,
        touchdownsCountAsFirstDowns: true,
        teamLossOnly: [],
        collectStatsOnPat: false,
        collectStatsForOnSideKicks: false,
        teamZoneQty: 1,
        promptToSkipKickoff: [],
        participationStyle: ParticipationStyle.Default.code
    },
    clock: {
        clockType: ClockType.DESC.code,
        // When true, the game context is created with a real-time running
        // clock instead of a manual one. Toggleable mid-game via
        // ContextService.reconcileClock.
        runningClock: false
    },
    spots: {
        kickoff: 35,
        KOTouchback: 25,
        otherTouchback: 20,
        PATTry: 3,
        safetyKO: 20,
        driveStartingYardline: 14,
        touchbackYardline: 25,
        rougeYardline: 40,
        overtimeStartingYardline: 10,
        spotsPatScoreOption1: 3,
        spotsPatScoreOption2: 10,
        spotsPatScoreOption3: 20,
        goalPostLocation: GoalPost.END_LINE.code,
        missedFieldGoalMinSpot: 20,
        missedFieldGoalSpot: null
    },
    scoring: {
        touchdown: 6,
        kickPAT: 1,
        runPAT: 2,
        safety: 2,
        rougePoints: 1,
        fieldGoal: 3,
        defensivePAT: 2,
        scoringPatScoreOption1: PatPoints.OptionOne.value,
        scoringPatScoreOption2: PatPoints.OptionTwo.value,
        scoringPatScoreOption3: PatPoints.OptionThree.value,
        playSummary: true
    }
});

export default DefaultFootballConfig;
